<template>
    <div id="app"
         class="page"
    >
        <TheHeader logo-link />

        <main class="main">
            <slot />
        </main>

        <TheModal class="modal" />

        <TheOverlay />
    </div>
</template>

<script setup>
    import { tryOnBeforeUnmount } from '@vueuse/core'
    import { useOverlayStore } from '~/src/shared/pinia/useOverlayStore'
    import TheHeader from '~/src/widgets/header/TheHeader.vue'
    import TheModal from '~/src/widgets/modal/TheModal.vue'
    import TheOverlay from '~/src/widgets/overlay/TheOverlay.vue'

    const { isShowOverlay, hideOverlay } = useOverlayStore()

    tryOnBeforeUnmount(() => {
        if (isShowOverlay) {
            hideOverlay()
        }
    })
</script>

<style lang="scss" scoped>
    .page {
        display: flex;
        flex-flow: column;
        min-width: 320px;
        max-width: calc(100% - var(--lock-offset, 0));
        min-height: 100vh;
        min-height: 100dvh;
        background-color: var(--blue-100);

        :deep(.header) {
            --header-background-color: var(--white);
        }
    }

    .main {
        position: relative;
        flex: auto;
    }

    .modal {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 1000;
    }
</style>
